/* Keeps the big price at the top of the buy box in sync with the chosen bundle. */
(function () {
  function moneyLeaves(root) {
    return Array.prototype.filter.call(root.querySelectorAll('*'), function (e) {
      if (e.children.length) return false;
      var t = e.textContent.trim();
      return /^[^A-Za-z]*[€$£¥][\d\s.,]+$/.test(t);
    });
  }
  function selectedTier() {
    var tiers = document.querySelectorAll('lumin-product-qty-break');
    for (var i = 0; i < tiers.length; i++) {
      var input = tiers[i].querySelector('input');
      if (input && input.checked) return tiers[i];
    }
    return null;
  }
  function apply() {
    var tier = selectedTier();
    if (!tier) return;
    // read every amount printed in the selected card, whatever its markup: lowest = what she pays, highest = crossed
    var found = (tier.innerText || '').match(/€\s?\d[\d\s.]*,\d{2}|\d[\d\s.]*,\d{2}\s?€/g) || [];
    if (!found.length) return;
    var num = function (s) { return parseFloat(s.replace(/[^\d,]/g, '').replace(',', '.')) || 0; };
    found.sort(function (x, y) { return num(x) - num(y); });
    var total = found[0].trim();
    var compare = num(found[found.length - 1]) > num(found[0]) ? found[found.length - 1].trim() : '';
    var box = document.querySelector('.price');
    if (box) {
      box.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale').forEach(function (e) { e.textContent = total; });
      var strike = box.querySelector('.price-item--strikethrough');
      if (strike) strike.textContent = compare;
      box.classList.toggle('price--on-sale', !!compare);
    }
    var badge = box ? box.querySelector('.price__badge-sale') : null;
    if (badge) {
      var n = function (t) { return parseFloat(t.replace(/[^\d,.-]/g, '').replace(/\s/g, '').replace(',', '.')) || 0; };
      var a = n(compare), b2 = n(total);
      if (a > b2 && a > 0) { badge.textContent = '- ' + Math.round((a - b2) / a * 100) + '%'; badge.hidden = false; }
      else { badge.hidden = true; }
    }
    var sticky = document.querySelector('[data-av-price]');
    if (sticky) sticky.textContent = total;
  }
  function schedule() { setTimeout(apply, 60); setTimeout(apply, 400); setTimeout(apply, 1100); }
  document.addEventListener('change', schedule);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('lumin-product-qty-break')) schedule();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();

/* Sonelie: the bundle rows have no size/colour pickers of their own (hidden, Anas 2026-09-30).
   Every item in every bundle takes the size + colour chosen at the top of the page. */
(function () {
  function topChoice() {
    var vs = document.querySelector('variant-selects');
    if (!vs) return null;
    return Array.prototype.map.call(vs.querySelectorAll('fieldset'), function (f) {
      var c = f.querySelector('input:checked'); return c ? c.value : null;
    });
  }
  function sync() {
    var vals = topChoice(); if (!vals) return;
    document.querySelectorAll('.lumin-product-block-qty-break-variant').forEach(function (row) {
      var changed = null;
      row.querySelectorAll('select').forEach(function (s, i) {
        if (vals[i] != null && s.value !== vals[i]) { s.value = vals[i]; changed = s; }
      });
      if (changed) changed.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-selects')) { setTimeout(sync, 60); setTimeout(sync, 900); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  window.addEventListener('load', sync);
})();
